import { Component, input } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

@Component({
selector: 'app-loading-text',
templateUrl: './loading-text.component.html',
styleUrl: './loading-text.component.scss',
imports: [FaIconComponent],
})
export class LoadingTextComponent {

	public text = input<string>('Aguarde...');

	public icons = {
		spinner: faSpinner,
	};
}
